import React, { FC } from 'react';
import { useQuery } from 'react-query';
import Skeleton from 'react-loading-skeleton';
import PostApi from 'api/post';
import { useTranslation } from 'react-i18next';
import { queryKey } from 'constants/queryKey';
import ArrayUtils from 'app/utils/array';
import { Alert, mergeTailwindClasses } from '@kontentino/ui';
import AccordionWidgetEmptyMessage from 'app/modules/posts/components/accordionWidget/AccordionWidgetEmptyMessage';
import clsx from 'clsx';
import ActivityLogRecordList from 'app/modules/posts/modules/post/components/postCommunication/activityLog/ActivityLogRecordList';
import ActivityLogPostId from 'app/modules/posts/modules/post/components/postCommunication/activityLog/ActivityLogPostId';

type Props = {
  postId: number;
  className?: string;
};

const skeletons = ArrayUtils.generate(10);

const ActivityLog: FC<Props> = ({ postId, className }) => {
  const { t } = useTranslation();
  const { isLoading, isError, data } = useQuery(
    queryKey.postActivityLog(postId),
    () => PostApi.getActivityLog(postId),
  );

  return (
    <div className="tw-flex tw-h-full tw-min-h-0 tw-flex-col tw-pt-4">
      <ActivityLogPostId postId={postId} />
      <div
        className={mergeTailwindClasses(
          clsx(
            'tw-flex tw-h-full tw-flex-col tw-overflow-y-auto tw-py-4',
            {
              'tw-justify-start': !!data?.length,
              'tw-justify-center': !data?.length,
            },
            className,
          ),
        )}
      >
        {isLoading &&
          skeletons.map((item) => <Skeleton height={30} key={item} />)}
        {isError && (
          <Alert className="tw-justify-s" variant="danger">
            {t('somethingWentWrongTryAgain')}
          </Alert>
        )}
        {data && <ActivityLogRecordList data={data} />}
        {data?.length === 0 && (
          <AccordionWidgetEmptyMessage message={t('noActivityRecordedYet')} />
        )}
      </div>
    </div>
  );
};

export default ActivityLog;
